export default {
  title: {
    en: 'We\'re updating<br/>our site',
  },
  text: {
    en: 'You\'ve sniffed out something we\'re in the process of updating. Please try reloading it in a few minutes.',
  },
}
